import React from "react";
import { Helmet } from "react-helmet";
import { SITE_ORIGIN } from "./LocalBusinessJsonLd";

const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/assets/home.jpeg`;

/**
 * Shared per-page metadata: title, description, self-referencing canonical,
 * robots, Open Graph, and Twitter card. Keeps the 20+ individual service
 * pages from repeating the same Helmet block. Pages with existing, working
 * inline Helmet blocks (Home, About, Contact, Blogs, Services, and the 5
 * dedicated landing pages) are left as-is rather than migrated, to avoid
 * touching already-correct code during this pass.
 */
export default function SeoHead({
  title,
  description,
  path,
  image = DEFAULT_OG_IMAGE,
  robots = "index, follow",
}) {
  const canonical = `${SITE_ORIGIN}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Advanced Automotive Smog" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
